import { useEffect } from 'react';
import { useTasks } from '@battleops/client/src/context/TaskContext';
import { prompt } from '../Dialog';

// "Ask for a note on done" (v0.1.247, a department's task defaults): a task finished there asks for one line; it lands on
// the task's notes. Cancel = skip.
export default function DoneNote() {
  const { pendingNote: task, clearNote, addNote } = useTasks();
  useEffect(() => {
    if (!task) return;
    let live = true;
    prompt({ title: 'Done — a note?', message: task.title, placeholder: 'How did it go? Anything the next person needs…', multiline: true }).then((v) => {
      if (live && v && v.trim()) addNote(task.id, v.trim());
      clearNote();
    });
    return () => { live = false; };
  }, [task?.id]);   // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
